import { useQuery } from '@tanstack/react-query'
import { getInvoicesPaginated, type InvoiceFilters, type InvoicePagination } from './endpoints'

export const INVOICES_V3_KEY = 'invoices-v3'

export const useInvoicesPaginated = (filters: InvoiceFilters, pagination: InvoicePagination) => {
  return useQuery({
    queryKey: [INVOICES_V3_KEY, filters, pagination],
    queryFn: () => getInvoicesPaginated(filters, pagination),
    refetchOnWindowFocus: false,
    keepPreviousData: true,
  })
}
